import React from "react";
import { LazyLoadImage } from "react-lazy-load-image-component";
import { HiOutlinePhone } from "react-icons/hi";
import { BsStarFill, BsStarHalf, BsBookmarkPlus } from "react-icons/bs";
import { leaf } from "../assets";
import { BiCaretDownCircle } from "react-icons/bi";
import { useNavigate } from "react-router-dom";
import { Link as ScrollLink } from "react-scroll";

const HomeSlide = ({ banner, heading, desc }) => {
  const navigate = useNavigate();
  return (
    <div className="container">
      <div className="banner">
        <LazyLoadImage effect="blur" src={banner} alt="" />
      </div>

      <div className="details">
        <h3>Welcome to Leaser Treat</h3>
        <h1>{heading}</h1>
        <p className="shortDesc">{desc}</p>

        <ScrollLink
          className="seeBelow"
          to="treatments"
          smooth={true}
          duration={500}
          offset={-150}
          spy={true}
          style={{ cursor: "pointer" }}
        >
          <p>See our treatments</p>
          <BiCaretDownCircle className="downArrow" />
        </ScrollLink>

        {/* <div className="review">
          <div className="line"></div>
          <div className="rating">
            <h2>4.4</h2>
            <div className="stars">
              <div className="star">
                <BsStarFill className="fillStar" />
                <BsStarFill className="fillStar" />
                <BsStarFill className="fillStar" />
                <BsStarFill className="fillStar" />
                <BsStarFill className="fillStar" />
                <BsStarHalf className="halfStar" />
              </div>
              <small>100+ Reviews</small>
            </div>
          </div>
        </div> */}

        <div className="headerButtons">
          <button
            className="highLight"
            onClick={() => navigate("/appointment")}
          >
            <p>Book Appointment</p>
          </button>
          <button className="nonHighLight">
            <a href="tel:+8809678006007">
              <HiOutlinePhone className="io" />
              Call Now
            </a>
          </button>
        </div>
      </div>
    </div>
  );
};

export default HomeSlide;
